
import { i18nText } from '@/locales';

import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {Tabs} from "ant-design-vue";
import {Component} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {SimpleProxyForm} from "@/UI/components/Helpers/SimpleProxyForm";
import {RouterNameEnum} from "@/router/router.types";
import {getStudioId} from "@/UI/lib/state";
import { checkUserRole, getUserData } from '@/router/Lib/helper';

@Component({
  components: {
    BaseDataForm,
    "a-tab": Tabs,
    "a-tab-pane": Tabs.TabPane,
  },
  methods: {
    checkUserRole
  }
})
export default class LoayltyIndex extends mixins(SimpleProxyForm) {
  tabs = [
    {
      id: RouterNameEnum.ClientDetailLoyaltyPage,
      name: i18nText("Абонементы"),
      hide: 'owner',
      meta: {
        alias: RouterNameEnum.ClientDetailLoyaltyPage,
      },
      params: {
        meta: {
          alias: RouterNameEnum.ClientDetailLoyaltyPage,
        },
        name: RouterNameEnum.ClientDetailLoyaltyPage,
        params: {Studio: getStudioId(this)},
      },
    },
    {
      id: RouterNameEnum.clientsDetailLoyaltyCertificates,
      name: i18nText("Сертификаты"),
      meta: {
        alias: RouterNameEnum.clientsDetailLoyaltyCertificates,
      },
      params: {
        meta: {
          alias: RouterNameEnum.clientsDetailLoyaltyCertificates,
        },
        name: RouterNameEnum.clientsDetailLoyaltyCertificates,
        params: {Studio: getStudioId(this)},
      },
    },
  ];

  tabChanged(key: string): void {
    /* this.$router.push({name: key}); */
    setTimeout(() => {
      this.$router.push({name: key});
    }, 2000)
  }

  async created(): Promise<void> {
    this.formReady = true;
  }
}
